
import { TranslationSet } from '../types';

export const statistics: TranslationSet = {
  'statistics.title': {
    en: 'Growth Statistics',
    ja: '成長統計',
    es: 'Estadísticas de crecimiento',
    zh: '成长统计',
    fa: 'آمار رشد'
  },
  'statistics.subtitle': {
    en: 'Track your baby\'s growth and development.',
    ja: '赤ちゃんの成長と発達を追跡します。',
    es: 'Monitorea el crecimiento y el desarrollo de tu bebé.',
    zh: '跟踪宝宝的成长和发育。',
    fa: 'رشد و تکامل کودک خود را پیگیری کنید.'
  },
  'statistics.selectTimeRange': {
    en: 'Select time range',
    ja: '期間を選択',
    es: 'Seleccionar rango de tiempo',
    zh: '选择时间范围',
    fa: 'بازه زمانی را انتخاب کنید'
  },
  'statistics.lastMonth': {
    en: 'Last month',
    ja: '先月',
    es: 'Último mes',
    zh: '上个月',
    fa: 'ماه گذشته'
  },
  'statistics.lastThreeMonths': {
    en: 'Last 3 months',
    ja: '過去3ヶ月',
    es: 'Últimos 3 meses',
    zh: '最近3个月',
    fa: '۳ ماه گذشته'
  },
  'statistics.lastSixMonths': {
    en: 'Last 6 months',
    ja: '過去6ヶ月',
    es: 'Últimos 6 meses',
    zh: '最近6个月',
    fa: '۶ ماه گذشته'
  },
  'statistics.lastYear': {
    en: 'Last year',
    ja: '去年',
    es: 'Último año',
    zh: '去年',
    fa: 'سال گذشته'
  },
  'statistics.allTime': {
    en: 'All time',
    ja: '全期間',
    es: 'Todo el tiempo',
    zh: '全部时间',
    fa: 'تمام زمان‌ها'
  },
  'statistics.height': {
    en: 'Height',
    ja: '身長',
    es: 'Altura',
    zh: '身高',
    fa: 'قد'
  },
  'statistics.weight': {
    en: 'Weight',
    ja: '体重',
    es: 'Peso',
    zh: '体重',
    fa: 'وزن'
  },
  'statistics.heightChartTitle': {
    en: 'Height Over Time',
    ja: '身長の推移',
    es: 'Crecimiento en altura',
    zh: '身高变化',
    fa: 'نمودار قد در طول زمان'
  },
  'statistics.weightChartTitle': {
    en: 'Weight Over Time',
    ja: '体重の推移',
    es: 'Crecimiento en peso',
    zh: '体重变化',
    fa: 'نمودار وزن در طول زمان'
  },
  'statistics.noDataAvailable': {
    en: 'No data available to display statistics.',
    ja: '統計を表示するためのデータがありません。',
    es: 'No hay datos disponibles para mostrar estadísticas.',
    zh: '没有数据可供显示统计信息。',
    fa: 'داده‌ای برای نمایش آمار موجود نیست.'
  },
  'statistics.showAverage': {
    en: 'Show average',
    ja: '平均を表示',
    es: 'Mostrar promedio',
    zh: '显示平均值',
    fa: 'نمایش میانگین'
  },
  'statistics.switchTo': {
    en: 'Switch to',
    ja: '切り替える：',
    es: 'Cambiar a',
    zh: '切换到',
    fa: 'تغییر به'
  },
  'statistics.metric': {
    en: 'Metric',
    ja: 'メトリック',
    es: 'Métrico',
    zh: '公制',
    fa: 'متریک'
  },
  'statistics.imperial': {
    en: 'Imperial',
    ja: 'インペリアル',
    es: 'Imperial',
    zh: '英制',
    fa: 'امپریال'
  },
  'statistics.heightGrowth': {
    en: 'Height Growth',
    ja: '身長の成長',
    es: 'Crecimiento en altura',
    zh: '身高增长',
    fa: 'رشد قد'
  },
  'statistics.heightProgress': {
    en: 'Track your baby\'s height progress over time',
    ja: '赤ちゃんの身長の推移を時間とともに追跡する',
    es: 'Sigue el progreso de altura de tu bebé a lo largo del tiempo',
    zh: '随时间跟踪宝宝的身高进展',
    fa: 'روند رشد قد کودک خود را در طول زمان پیگیری کنید'
  },
  'statistics.weightGrowth': {
    en: 'Weight Growth',
    ja: '体重の成長',
    es: 'Crecimiento en peso',
    zh: '体重增长',
    fa: 'افزایش وزن'
  },
  'statistics.weightProgress': {
    en: 'Track your baby\'s weight progress over time',
    ja: '赤ちゃんの体重の推移を時間とともに追跡する',
    es: 'Sigue el progreso de peso de tu bebé a lo largo del tiempo',
    zh: '随时间跟踪宝宝的体重进展',
    fa: 'روند افزایش وزن کودک خود را در طول زمان پیگیری کنید'
  },
  'statistics.editBabyProfile': {
    en: 'Edit Baby Profile',
    ja: '赤ちゃんのプロフィールを編集',
    es: 'Editar perfil del bebé',
    zh: '编辑宝宝档案',
    fa: 'ویرایش پروفایل کودک'
  },
  'statistics.editFamilyProfile': {
    en: 'Edit Family Profile',
    ja: '家族のプロフィールを編集',
    es: 'Editar perfil familiar',
    zh: '编辑家庭档案',
    fa: 'ویرایش پروفایل خانواده'
  },
  'statistics.birthHeight': {
    en: 'Birth Height',
    ja: '出生時の身長',
    es: 'Altura al nacer',
    zh: '出生身高',
    fa: 'قد هنگام تولد'
  },
  'statistics.birthWeight': {
    en: 'Birth Weight',
    ja: '出生時の体重',
    es: 'Peso al nacer',
    zh: '出生体重',
    fa: 'وزن هنگام تولد'
  }
};
